import { render, staticRenderFns } from "./PostalCodeValidator.vue?vue&type=template&id=383341a8&"
import script from "./PostalCodeValidator.vue?vue&type=script&lang=js&"
export * from "./PostalCodeValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports